var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
// BluePrint JS
import { Checkbox as BPCheckbox } from '@blueprintjs/core';
import classNames from 'classnames';
// constants
import { prefix } from '../../constants';
// Icons
import { Icons } from '../Icons';
export const Checkbox = (_a) => {
    var { focused, error, variant } = _a, props = __rest(_a, ["focused", "error", "variant"]);
    return (React.createElement("div", { className: "checkbox-container" },
        React.createElement(BPCheckbox, Object.assign({ className: classNames(`${prefix}-checkbox`, `style-${variant}`, {
                checkbox: true,
                focused,
                error,
            }) }, props)),
        error && typeof error === 'string' && (React.createElement("div", { className: "form-group__error" },
            React.createElement(Icons, { size: 16, iconName: "ic-ui-exclamation-sign" }),
            React.createElement("p", { className: "form-group__error-text" }, error)))));
};
//# sourceMappingURL=Checkbox.js.map